import { DoqType } from '@ardoq/doq';
import { Link } from '@ardoq/link';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { Trans, t, type I18nLocale } from '@ardoq/i18n';
import { orgAdminsListCommands } from 'admin/orgAdminsList/commands';

type UnknownDocumentArchiveErrorDialogProps = {
  workspaceName: string | null;
  i18nLocale: I18nLocale;
};

const UnknownDocumentArchiveErrorDialog = ({
  workspaceName,
  i18nLocale,
}: UnknownDocumentArchiveErrorDialogProps) => {
  return (
    <>
      <div>
        {t(
          i18nLocale,
          'documentArchive:noPermissionDialog.workspaceLabel',
          'Workspace:'
        )}{' '}
        {workspaceName}
      </div>
      <div>
        <Trans
          i18nKey="documentArchive:noPermissionDialog.contactAdminLine"
          defaults="<adminLink>Contact your admin</adminLink> to get Write access."
          components={{
            adminLink: (
              <Link
                typography="text2"
                hideIcon
                onClick={() => orgAdminsListCommands.openDialog()}
              />
            ),
          }}
        />
      </div>
    </>
  );
};

export const unknownDocumentArchiveErrorDialog = (
  workspaceName: string | null
) => {
  // i18nLocale$.state OK here: snapshot-at-open-time; /modal renders alert() body once and does not re-render on locale change
  const i18nLocale = i18nLocale$.state;
  return {
    title: t(
      i18nLocale,
      'documentArchive:noPermissionDialog.unexpectedErrorTitle',
      'An unexpected error occurred'
    ),
    subtitle: t(
      i18nLocale,
      'documentArchive:noPermissionDialog.unexpectedErrorSubtitle',
      'Please try again, or contact support if the problem persists. If you are trying to archive a document, you need Write access to the workspace.'
    ),
    body: (
      <UnknownDocumentArchiveErrorDialog
        workspaceName={workspaceName}
        i18nLocale={i18nLocale}
      />
    ),
    doqType: DoqType.LOCKED,
  };
};
